import {
  GetHeaderV2Response_SubBrands,
  GetHeaderV2Response_SubBrands_SubBrand,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.types';
import {
  BORDER,
  BrandTileCompact,
  Button,
  COLORS,
  desktopAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useShopSeoLink} from '../../../../features/Seo/useShopSeoLink';
import {BrandTileTracked} from '../../BrandHubTracking/BrandTileTracked';
import {BRAND_SHOP_ANCHOR_LIST} from '../../utils/anchorList';
import {useActiveSubBrand} from './utils/useActiveSubBrand';

export const BrandPageSubBrandsList: React.FC<{
  subBrands: GetHeaderV2Response_SubBrands;
}> = ({subBrands}) => {
  const getters = useActiveSubBrand({
    subBrands,
    parentBrand: subBrands.parentBrand,
  });

  return (
    <>
      {subBrands.subBrands.map((subBrand, index) => (
        <SubBrand
          key={index}
          subBrand={subBrand}
          index={index}
          getters={getters}
        />
      ))}
    </>
  );
};

const SubBrand: React.FC<{
  subBrand: GetHeaderV2Response_SubBrands_SubBrand;
  index: number;
  getters: ReturnType<typeof useActiveSubBrand>;
}> = ({subBrand, index, getters}) => {
  const {getBrandState, getBrandRedirectUrl} = getters;
  const {brand, whiteLogoImage} = subBrand;
  const state = getBrandState(brand.id);
  const brandPath = getBrandRedirectUrl({
    brand,
    brandPreview: undefined,
  });
  const {to, ...handlers} = useShopSeoLink({to: brandPath, preserveParams: []});

  const dataTestId = `BrandLogoSlider_${state}_${brand.name}`;

  return (
    <BrandTileTracked key={brand.id} brand={brand} position={index}>
      <BrandTileLink
        considerScrollTopAnchor
        scrollTopAnchorId={BRAND_SHOP_ANCHOR_LIST.subBrandSlider}
        aria-label={undefined}
        size="fit-width"
        variant="glassy"
        data-is-selected={state === 'selected' ? 'true' : 'false'}
        href={to}
        {...handlers}
      >
        <BrandTileCompact
          data-testid={dataTestId}
          isSelected={state === 'selected'}
          brandName={brand.name}
          image={whiteLogoImage}
        />
      </BrandTileLink>
    </BrandTileTracked>
  );
};

const BrandTileLink = styled(Button)`
  &&& {
    // fixes a chrome-bug that makes backdrop-filter not working when a
    // 'mix-blend-mode' is set on the page (is set in the BrandTile)
    backdrop-filter: opacity(1);
    height: 40px;
    min-height: 40px;
    padding-inline: 2px;
    --color: ${COLORS['Text.White']};
    --border-width: 0;

    box-shadow: inset 0 0 0 var(--border-width) var(--border-color);

    &[data-is-selected='true'] {
      --border-width: ${BORDER.Sm};
    }

    ${desktopAndUpLinaria(`
      &:hover {
        --border-width: ${BORDER.Sm};
      }
    `)}
  }
`;
